import { useMemo } from "react";
import { useServices } from "@core/servicesContext";
import { StorePresentation } from "@core/store/storePresentation";
import { PaginatedDataResult, usePaginatedStoreWithArgsDirect } from "@utils/hooks";
import { SearchArguments } from "@domain/search/searchService";
import { Tag } from "./dtos";

export function useSuggestedTagsByValue(value: string): PaginatedDataResult<Tag> {
	const { tagsService } = useServices();
	const store = useMemo(() => {
		return new StorePresentation<Tag, SearchArguments>(tagsService.tagsStore, tagsService.suggestByValue);
	}, [value]);
	return usePaginatedStoreWithArgsDirect<Tag, unknown, SearchArguments>(store, [], value);
}
